module.exports = __webpack_public_path__ + "static/media/RotateRightButton.6c040921.svg";